import React from 'react';

export default function WBSBenchMarking() {
    return (
        <div>
            WBS Benchmarking View
        </div>
    );
}
